import { enumToString, STANDARD_DRIVER_REQUIREMENTS } from 'clerk_common/enums';

export const getDriverRequirementOptions = () => {
  return [...STANDARD_DRIVER_REQUIREMENTS].map((type) => ({
    id: type,
    label: enumToString(type),
  }));
};
